import { Component, OnInit, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
// import { MainBodyService } from '../../services/main-body.service';
import {  themeData } from 'src/interface/themesetting';
import { TranslateService } from '@ngx-translate/core';
// import { SharedService } from '../../services/shared.service';
import { EnvService } from '../../services/env.service';
// import { PublisherService } from '../../services/publisher.service';
import { UniversalStorageService } from 'src/app/services/universal-storage.service';
import { UserService } from 'src/app/user/user.service';
import { Listlang } from 'src/interface/lang';
// import { LanguagesService } from 'src/app/services/languages.service';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-footer',
    templateUrl: './app-footer.component.html',
    styleUrls: ['./app-footer.component.scss'],
    
})
export class AppFooterComponent implements OnInit {
    themeSettingsData: themeData;
    yourTranslatedObservableText: string;
    journalId = '';
    themePath = '';
    publisher_id: string;
    currentCountryCode = 'gb';
    activeLanguages: Listlang[];
    subscription: Subscription[] = [];
    currentYear: number;
    showLanguageDropDown=false


    constructor(
        // private mainBodyService: MainBodyService,
        private translateService: TranslateService,
        // private sharedService: SharedService,
        private EnvService: EnvService,
        // private publisherService: PublisherService,
        private storageService: UniversalStorageService,
        private userService: UserService,
        // private langService: LanguagesService, 
        @Inject(PLATFORM_ID) private platformId: any
    ) {
        this.themeSettingsData = {
            journal_id: '',
            journal_logo: '',
            logo_alt_text: '',
            journal_banner: '',
            journal_display_name: '',
            banner_type: '',
            banner_heading: '',
            banner_content: '',
            banner_secondary_content: '',
            button_label: '',
            button_link: '',
            contact_us: {
                address_line_1: '',
                address_line_2: '',
                address_line_3: '',
                phone_number: 9123456789,
                email: ''
            },
            journal_about: '',
            social_media_links: [{
                label: 'Facebook link',
                key: 'facebook_link',
                icon: ['fab', 'facebook'],
                value: 'facebook.com',
            }],
            theme_colors: {
                button_color: '',
                button_text_color: '',
                primary_color: '',
                primary_footer_background_color: '',
                primary_footer_text_color: '',
                primary_header_background_color: '',
                primary_header_text_color: '',
                secondary_color: '',
                secondary_footer_background_color: '',
                secondary_footer_text_color: '',
                secondary_header_background_color: '',
                secondary_header_text_color: '',
                text_primary_color: '',
                text_secondary_color: ''
            },
            fullwidthcheck: '',
            transimagecheck: '',
            banner_transparent_image: '',
            banner_fullwidth_image: '',
            banner_full_alt_text: '',
            banner_trans_alt_text: '',
            about: '',
            journal_title: ''
        }
    }
    /**
     * Back to top button
     */
    @HostListener('window:scroll', ['$event'])
    doSomething() {
        if (isPlatformBrowser(this.platformId)) {
            // const backtotop = document.querySelector('.back-to-top');
            if (window.scrollY > 100) {
                // backtotop.classList.add('active')
            } else {
                //backtotop.classList.remove('active')
            }
        }
    }
    /* end of back to top  */
    rss_feed_url: string;
    
    ngOnInit(): void {
        this.rss_feed_url = this.EnvService.rssFeed;
        this.currentYear = new Date().getFullYear();
        /*********************api call for fetch publisher id and themesettinngs data */
        // this.publisherService.fetchPublisherId().subscribe(response => {
        //     this.publisher_id = response[0].publisher_id;
        //     this.sharedService.getJournalId().subscribe(journalId => {
        //         this.journalId = journalId ? journalId : this.journalId;
        //     });
        //     this.themePath = this.EnvService.imageUrl + 'themes/';

        //     this.mainBodyService.getAllThemeSettings(this.publisher_id).subscribe((result: responsedata) => {

        //         if (result.status === 200 && result.data) {
        //             this.themeSettingsData = result.data;

        //             const color = this.themeSettingsData.theme_colors;
        //             if (isPlatformBrowser(this.platformId) && color) {
        //                 Object.entries(color).map(([key, value]) => {
        //                     const element = "--" + key;
        //                     const val: string = value;
        //                     document.documentElement.style.setProperty(element, val);
        //                 });
        //             }

        //             if (this.themeSettingsData.journal_logo) {
        //                 const logo_url = this.EnvService.imageUrl + "themes/" + this.themeSettingsData.journal_logo;
        //                 this.themeSettingsData.journal_logo = logo_url;
        //             }
        //         } else {
        //             // Handle the case where result.status is not 200 or result.data is null/undefined
        //             // You can choose an appropriate default value or error handling here
        //         }
        //     });

        //     const languageSub = this.langService
        //         .getActiveLang()
        //         .subscribe((result: listresponse) => {
        //             if (
        //                 result &&
        //                 result.status === 200 &&
        //                 result.data &&
        //                 result.data.length > 0
        //             ) {
        //                 this.activeLanguages = result.data;
        //                 this.storageService.setItem(
        //                     'language',
        //                     result.data[0].country_language_code
        //                 );
        //             }
        //         });
        //     this.subscription.push(languageSub);


        //     this.translateService.get('app_footer.footer_information.string').subscribe((translatedString) => {
        //         this.yourTranslatedObservableText = translatedString;
        //     })
        // });
        /*********************************api call completetd*********************************************************** */
    }
    // setStyle(media_key: string) {
    //     if (media_key == 'facebook_link') return { 'color': '#3b5998' };
    //     else if (media_key == 'youtube_link') return { 'color': '#FF0000' };
    //     else if (media_key == 'twitter_link') return { 'color': ' #55acee' };
    //     else if (media_key == 'dropbox_link') return { 'color': ' #3d9ae8;' };
    //     else return
    // }
    // returnSocialMedia(journalSettingData: themeData) {
    //     let links: mediaLink[] = [];
    //     if (journalSettingData.social_media_links) {
    //         links = journalSettingData.social_media_links;
    //     }
    //     return links;
    // }
    changeSiteLanguage(language_code: string): void {
        const splittedArray: string[] = language_code.split('-');
        const countryCode: string = splittedArray[1];
        this.currentCountryCode = countryCode?.toLowerCase();
        this.storageService.setItem('language', language_code);

        this.translateService.use(language_code);
        this.translateService.currentLang = language_code;
        this.userService.languageChange.next('vfdgbh');
    }
    returnCountryCode(country_language_code: string) {
        const splittedArray = country_language_code.split('-');
        return splittedArray[1]?.toLowerCase();
    }
    
    loadRssFeed() {
        this.rss_feed_url = this.EnvService.rssFeed;
    }


}
